module.exports = __webpack_public_path__ + "static/media/delete.d0fd1b01.svg";